import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import { formatPhone } from 'utils/formatPhone';
import uuid from 'utils/uuid';
import inCommingCallIcon from './calling.gif';
import useCallerId from './useCallerId';
import moment from 'utils/moment';

type Props = {
  customer: ICustomerUI | null;
  style?: React.CSSProperties;
  index?: number;
  onClose: () => void;
  createdAt: number;
  callerId?: string;
};

const CallerIdCard = ({ customer, onClose, createdAt, callerId }: Props) => {
  const [closeId] = useState(uuid());
  const services = useCallerId();

  const onBook = async () => {
    onClose();
    if (!customer) return;
    services.book(callerId || '', customer);
  };

  const onSMS = async () => {
    onClose();
    if (!customer) return;
    services.sms(callerId || '', customer);
  };

  return (
    <>
      <Container>
        <Body>
          <img src={inCommingCallIcon} alt="inCommingCallIcon" className='icon' />

          <div className='calling-container'>
            <span className='label'>Incoming call... {moment(createdAt).format('HH:mm:ss')}</span>
            <div className='cus-phone'>
              <span className='phone-label'>{customer?.name || 'Unknown name'}</span>
              <span className='phone-number'>{customer?.phone ? formatPhone(customer.phone) : '--'}</span>
            </div>
          </div>
        </Body>
        <Footer>
          <ButtonClose key={closeId} onClick={onClose} />
          <button onClick={onSMS} type='button' className="btn btn-sms"><span>SMS</span></button>
          <button onClick={onBook} type='button' className="btn btn-submit"><span>BOOK</span></button>
        </Footer>
      </Container>
    </>
  );
};

export default CallerIdCard;
const CreateAt = styled.div`
  
`;
const ButtonClose = ({ onClick }: { onClick: () => void }) => {
  const [secondsLeft, setSecondsLeft] = useState(30);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onClick();
    }
    const timer = setInterval(() => {
      setSecondsLeft((sec) => sec - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [secondsLeft]);

  return (
    <button onClick={onClick} type='button' className="btn">
      <span>{`CLOSE (${secondsLeft}s)`}</span>
    </button>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  overflow: hidden;
  width: 540px;
  background: #F8F9FE;
  zoom: 0.75;
`;

const Body = styled.div`
  display: flex;
  padding: 32px 24px 16px 24px;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  background: #fff;
  img.icon {
    width: 124px;
    height: 124px;
    aspect-ratio: 1/1;
  }

  .calling-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    .label {
      color: #00A140;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .cus-phone {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      align-self: stretch;
      span {
        color: #1D2129;
        font-family: Poppins;
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        &.phone-label {
          font-size: 32px;
          font-weight: 500;
        }
      }
    }
  }
`;

const Footer = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  button.btn {
    display: flex;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;
    background: #CCD4DC;
    box-shadow: 0 4px 8px -3px rgba(45, 35, 66, 0.30);

    &:active {
      opacity: 0.6;
    }

    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      white-space: nowrap;
    }

    &.btn-submit {
      background: #00A140;
      span {
        color: #ffffff;
      }
    }
    &.btn-sms {
      border: 1px solid #2D6772;
      background: #fff;
      span {
        color: #2D6772;
      }
    }
  }
`;
